<div
  class="switch-track"
  [ngClass]="{
    on: value
  }"
  (click)="switchChange()"
>
  <div class="switch-handler"></div>
</div>
